import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withStyles } from 'theme/withStyles';
import ListGroupItem from 'containers/ListGroupItem';

const styles = () => ({
  listGroupView: {
    margin: [0, 'auto', 30, 'auto'],
    maxWidth: 440,
  },
});

const ListGroup = ({ classes, data, groupName, onDone, onEdit, onRemove }) => (
  <div className={classnames('region-list-groups', classes.listGroupView)}>
    <ol>
      {data?.length > 0 ? (
        data.map((_, index) => (
          <ListGroupItem
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            index={index}
            groupName={groupName}
            onRemove={onRemove}
            onDone={onDone}
            onEdit={onEdit}
          />
        ))
      ) : (
        <ListGroupItem
          index={null}
          groupName={groupName}
          onRemove={onRemove}
          onDone={onDone}
          onEdit={onEdit}
        />
      )}
    </ol>
  </div>
);

ListGroup.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})),
  groupName: PropTypes.string.isRequired,
  onDone: PropTypes.func,
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
};

ListGroup.defaultProps = {
  data: [],
  onDone: undefined,
  onEdit: () => {},
  onRemove: () => {},
};

const mapStateToProps = ({ data }, { groupName }) => ({
  data: data[`${groupName}___list`],
});

const ListGroupStyled = withStyles(styles)(ListGroup);

export default connect(mapStateToProps)(ListGroupStyled);
